import { useGalleryCtx } from "@/contexts/gallery";
import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import SlideShow from "./slideshow";
import { GalleryItmes } from "../types/common";

export default function ExpandedView({ items }: { items: GalleryItmes }) {
  const { currentGalleryItem, setCurrentGalleryItem } = useGalleryCtx();

  const expandedRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (expandedRef.current) {
      const topPosition =
        expandedRef.current.getBoundingClientRect().top + window.scrollY - 120;

      window.scrollTo({
        top: topPosition,
        behavior: "smooth",
      });
    }
  }, [currentGalleryItem]);

  return (
    <motion.div
      ref={expandedRef}
      key="expanded"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
    >
      <div className="mx-auto w-full lg:w-[90%] xl:w-[80%]">
        {currentGalleryItem !== null && (
          <SlideShow
            items={items}
            currentItem={currentGalleryItem}
            close={() => setCurrentGalleryItem(null)}
          />
        )}
      </div>
    </motion.div>
  );
}
